import React, { Component } from 'react';
import axios from 'axios';

import { Button, Grid, withStyles, Typography, Container, FormControl, RadioGroup, Radio } from '@material-ui/core';
import './Vote.css';
import swal from 'sweetalert';
import VoteRes from './VoteRes';
import { API_URL, EVENT_ID, getUserID } from '../../constants';

const styles = (theme) => ({
  container: {
    padding: '0 5px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 5px 50px',
    },
  },
  selectBtn: {
    width: '50px',
    height: '50px',
    backgroundColor: 'rgba(2,90,60,0.25)',
    borderRadius: '3px',
    // display: 'flex',
  },
  radioBtn: {
    opacity: 0,
    position: 'absolute',
    width: '50px',
    height: '50px',
  },
  radioLabel: {
    cursor: 'pointer',
    width: '50px',
    height: '50px',
    color: '#fff',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  voteCnt: {
    position: 'absolute',
    right: 0,
    color: '#828282',
    fontSize: '14px',
  },
  submitContainer: {
    marginBottom: '10vh',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  submitBtn: {
    margin: '20px 0',
    padding: '10px 0',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0',
      margin: '15px 0',
      width: '50%',
    },
  },
});

class Vote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pgmId: sessionStorage.getItem('_in_session'),
      isVoted: false,
      isTimeout: false,
      selected: null,
      itemList: [],
      exList: [],
      voteCnt: 5, // 보팅:: 문항갯수
      totalCnt: 0,
      res1: 0,
      res2: 0,
      res3: 0,
      res4: 0,
      res5: 0,
      res6: 0,
      matches: window.matchMedia('(max-width:992px)').matches /*md=992px*/,
    };

    this.voteSubmit = this.voteSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ exList: new Array(Number(this.state.voteCnt)).fill(0, 0, Number(this.state.voteCnt)).map((r, i) => i + 1) });
    this.loadingData();
  }

  loadingData = async () => {
    try {
      axios
        .get(`${API_URL}/event/polls?eventId=${EVENT_ID}&channel=${this.props.channel}&session=${this.state.pgmId}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((res) => this.setState({ itemList: res.data.Items[0] }));
    } catch (e) {
      console.error(e);
    }
  };

  handleBtn = (val) => this.setState({ selected: val });

  handleRadioChange = (event) => {
    if (this.state.selected) {
      let t = document.getElementsByName('tx' + this.state.selected)[0];
      t.classList.remove('selected');
    }

    let f = document.getElementsByName('tx' + event.target.value)[0];
    f.classList.add('selected');
    this.setState({ selected: event.target.value });
  };

  voteSubmit() {
    if (!this.state.selected) return swal('', 'Please select a Answer', 'warning');

    if (this.props.callBack) return this.props.callBack();

    const username = sessionStorage.getItem('_in_name');

    fetch(`${API_URL}/voting/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: `evt=${EVENT_ID}&userid=${getUserID()}&username=${username}&channel=${this.props.channel}&answer=${this.state.selected}`,
    })
      .then((res) => swal('', 'submited', 'success'))
      .catch((err) => swal('', 'error', 'warning'));
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {this.state.isVoted === false ? (
          <Container className={classes.container}>
            <FormControl style={{ width: '100%' }}>
              <RadioGroup value={this.state.selected} onChange={this.handleRadioChange}>
                <Grid container style={{ width: '100%' }}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid
                        id="voting panel Grid"
                        container
                        item
                        xs={12}
                        style={{
                          padding: '10px',
                          margin: '20px 10px 0',
                          borderRadius: '5px',
                          border: '2px solid #e0e0e0',
                        }}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          item
                          xs={12}
                          style={{ fontWeight: 'bold', fontSize: '14px', padding: '2vh 0' }}
                        >
                          *Please answer the number based on the screen in real time.
                        </Grid>
                        <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                          <Grid item>
                            <div name={'tx1'} className={classes.selectBtn}>
                              <Radio value={1} className={classes.radioBtn} />
                              <label htmlFor="1" className={classes.radioLabel}>
                                1
                              </label>
                            </div>
                          </Grid>
                          <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                            <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                              &nbsp; Answer 1
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                          <Grid item>
                            <div name={'tx2'} className={classes.selectBtn}>
                              <Radio value={2} className={classes.radioBtn} />
                              <label htmlFor="2" className={classes.radioLabel}>
                                2
                              </label>
                            </div>
                          </Grid>
                          <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                            <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                              &nbsp; Answer 2
                            </Typography>
                          </Grid>
                        </Grid>

                        {this.state.voteCnt > 2 && (
                          <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                            <Grid item>
                              <div name={'tx3'} className={classes.selectBtn}>
                                <Radio value={3} className={classes.radioBtn} />
                                <label htmlFor="3" className={classes.radioLabel}>
                                  3
                                </label>
                              </div>
                            </Grid>
                            <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                              <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                                &nbsp; Answer 3
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                        {this.state.voteCnt > 3 && (
                          <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                            <Grid item>
                              <div name={'tx4'} className={classes.selectBtn}>
                                <Radio value={4} className={classes.radioBtn} />
                                <label htmlFor="4" className={classes.radioLabel}>
                                  4
                                </label>
                              </div>
                            </Grid>
                            <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                              <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                                &nbsp; Answer 4
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                        {this.state.voteCnt > 4 && (
                          <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                            <Grid item>
                              <div name={'tx5'} className={classes.selectBtn}>
                                <Radio value={5} className={classes.radioBtn} />
                                <label htmlFor="5" className={classes.radioLabel}>
                                  5
                                </label>
                              </div>
                            </Grid>
                            <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                              <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                                &nbsp; Answer 5
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                        {/* {this.state.voteCnt > 5 && (
                        <Grid container item xs={12} style={{ padding: '1vh 0' }}>
                          <Grid item>
                            <div className={classes.selectBtn} name={'tx6'}>
                              <Radio className={classes.radioBtn} value={6} />
                              <label className={classes.radioLabel} htmlFor="6">
                                6
                              </label>
                            </div>
                          </Grid>
                          <Grid item style={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                            <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                              &nbsp; Answer 6
                            </Typography>
                          </Grid>
                        </Grid>
                      )} */}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid className={classes.submitContainer} container item xs={12} justifyContent="center">
                    <Button className={classes.submitBtn} variant="outlined" color="primary" onClick={() => this.voteSubmit()}>
                      SEND
                    </Button>
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Container>
        ) : (
          <VoteRes channel={this.props.channel} count={this.props.count} voteId={this.props.voteId} exList={this.state.exList} />
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Vote);
